import { call, put, takeEvery } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eBienLaiViewChiTietActionTypeIds,
  IBienLaiPrintRequest,
  IBienLaiViewChiTietActionTypes,
} from "../../action-types/bien-lai/IBienLaiViewChiTietActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* bienLaiViewChiTietSaga(): any {
  // takeEvery (KHÔNG takeLatest): khi thanh toán nhiều QR cùng lúc, mỗi biên lai phải
  // nạp được viewmodel riêng (mỗi id 1 entry) — takeLatest sẽ huỷ load của biên lai trước
  // → mất bienLaiViewModel → mất nút In/Thu tiếp ở phiếu đó.
  yield takeEvery(eBienLaiViewChiTietActionTypeIds.LOAD_START, loadWorker);
  yield takeEvery(eBienLaiViewChiTietActionTypeIds.PRINT_START, printWorker);
}

function* loadWorker(action: IBienLaiViewChiTietActionTypes): any {
  const request = action.payload as number;
  const res: IBaseRespone = yield call(
    bienLaiThuApi.SelectByIDBienLai,
    request,
  );
  if (res.is_success) {
    yield put(rootActions.bienLai.bienLaiViewChiTiet.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.bienLai.bienLaiViewChiTiet.LOAD_ERRR({
        request: {
          id: request,
          mau_so: "",
        } as IBienLaiPrintRequest,
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}

function* printWorker(action: IBienLaiViewChiTietActionTypes): any {
  const request = action.payload as IBienLaiPrintRequest;
  try {
    const res: IBaseRespone = yield call(bienLaiThuApi.PrintBienLai, request);
    if (res.is_success) {
      yield put(
        rootActions.bienLai.bienLaiViewChiTiet.PRINT_SUCCESS({
          request: request,
          data: res.data,
        }),
      );
    } else {
      yield put(
        rootActions.bienLai.bienLaiViewChiTiet.PRINT_ERR({
          request: request,
          data: res.message ?? "Có lỗi",
        }),
      );
    }
  } catch (error) {
    yield put(
      rootActions.bienLai.bienLaiViewChiTiet.PRINT_ERR({
        request: request,
        data: "Có lỗi",
      }),
    );
  }
}
